import { render, staticRenderFns } from "./404.vue?vue&type=template&id=1845bf6d&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=1845bf6d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1845bf6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1845bf6d')) {
      api.createRecord('1845bf6d', component.options)
    } else {
      api.reload('1845bf6d', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=1845bf6d&scoped=true", function () {
      api.rerender('1845bf6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/error-page/404.vue"
export default component.exports